
import React, { useState, useEffect } from 'react';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import axios from 'axios'; // Import axios for API calls
import "./doctor-patient-ecg-datagrid.scss"
import { backendlink } from '../../config';
import { LoadIndicator } from 'devextreme-react';

const IntervalChart = ({ FiveMinIntervalID, setFiveMinIntervalID, record, user, patientToken, resetTrigger }) => {
  const [data, setData] = useState([]);
  const [selectedBoxId, setSelectedBoxId] = useState(null); // State to track the selected box
  const [loading, setLoading] = useState(false); // State to track loading status

    // Reset selectedBoxId when resetTrigger changes
    useEffect(() => {
      if (resetTrigger) {
          setSelectedBoxId(null); // Reset the selected box
      }
  }, [resetTrigger]);

  useEffect(() => {
    if (FiveMinIntervalID) {
      setSelectedBoxId(FiveMinIntervalID); // Set the selected box ID when FiveMinIntervalID changes
    }
  }, [FiveMinIntervalID]);

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Set loading to true before fetching data
      try {
        const response = await axios.get(backendlink + 'doctor/getpatientdaily',
          {
            params: {
              patienttoken: patientToken,
              ecgdataid: record.uid,
            },
            headers: {
              token: user.token,
            },
          });
        console.log('Transformed Data:', response.data.result);
        const transformedData = transformApiResponse(response.data.result);
        console.log('Transformed Data:', transformedData);
        setData(transformedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
      finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    if (record) {
      fetchData();
      setSelectedBoxId(null); // Reset selected box ID when fetching new data
    }
  }, [record]);

  // Transform API response to match the grid's data structure in column-major order
  const transformApiResponse = (apiData) => {
    //const ecgIntervalData = apiData[0].ecgIntervalData; // Assuming the first element contains the data
    const ecgIntervalData = apiData; // Assuming the first element contains the data

    const rows = 12; // Number of rows
    const cols = 24; // Number of columns

    // Group the 288 elements into 12 rows and 24 columns in column-major order
    return Array.from({ length: rows }, (_, rowIndex) => {
      const row = {
        rowTitle: `${rowIndex * 5}`, // Row title
      };

      for (let col = 0; col < cols; col++) {
        const index = col * rows + rowIndex; // Calculate the index in column-major order
        const interval = ecgIntervalData[index] || {}; // Get the interval or an empty object if out of bounds

        row[`h${col}`] = {
          id: interval.id || null,
          U: interval.ecgMode || 0,
          risk: interval.risk || 0,
        };
      }

      return row;
    });
  };

  const cellRender = (cellData) => {
    const { id, U, risk } = cellData.value || {};
    const isSelected = selectedBoxId === id; // Check if this box is selected
    // Define the condition for non-clickable cells
    const isNonClickable = id === null || U === null || U === undefined;

    return (
      <div
        // onClick={!isNonClickable && id !== FiveMinIntervalID ? () => setFiveMinIntervalID(id) : undefined} // Only set ID if it's different
      //   style={{
      //     width: '32px',
      //     height: '24px',
      //     backgroundColor: isNonClickable ? '#FFFFFF' : risk == true ? '#FFDAD6' : '#D7E3FF', // White for non-clickable cells
      //     display: 'flex',
      //     alignItems: 'center',
      //     justifyContent: 'center',
      //     cursor: isNonClickable ? 'default' : 'pointer', // Disable pointer for non-clickable cells
      //     userSelect: 'none',
      //     fontSize: 12,
      //     whiteSpace: 'nowrap',
      //     overflow: 'hidden',
      //     textOverflow: 'ellipsis',
      //     padding: 0,
      //     margin: 0,
      //     boxSizing: 'border-box',
      //     textAlign: 'center',
      //   }}
      // >
      onClick={() => {
        if (id) {
          setSelectedBoxId(id); // Set the selected box ID
          setFiveMinIntervalID(id); // Pass the ID to the parent
        }
      }}
      style={{
        width: '32px',
        height: '24px',
        backgroundColor: isNonClickable ? '#FFFFFF' : risk === true ? '#FFDAD6' : '#D7E3FF', // Red for risk=true, green for risk=false
        opacity: selectedBoxId === null || isSelected ? 1 : 0.25, // Opacity logic
        border: isNonClickable
        ? 'none' // No border for non-clickable boxes
        : isSelected
        ? '1px solid var(--Schemes-Surface-On-Surface, #181C23)' // Border for selected boxes
        : 'none', // No border for non-selected boxes
        borderRight: isNonClickable
        ? 'none' // No border for non-clickable boxes
        : isSelected
        ? '2px solid var(--Schemes-Surface-On-Surface, #181C23)' // Border for selected boxes
        : 'none', // No border for non-selected boxes
        alignItems: 'center',
        justifyContent: 'center',
        cursor: id ? 'pointer' : 'default',
        userSelect: 'none',
        fontSize: 12,
        whiteSpace: 'nowrap',
        padding: 0,
        margin: 0,
        boxSizing: 'border-box',
      }}
    >
        {id !== null && U == 'UAM' ? 'U' : ''}
      </div>
    );
  };

  // Columns: first column is rowTitle, fixed and styled differently
  const rowTitleColumn = (
    <Column
      key="rowTitle"
      dataField="rowTitle"
      caption=""
      width={32}
      allowSorting={false}
      allowFiltering={false}
      allowEditing={false}
      cellRender={(cellData) => (
        <div
          style={{
            fontWeight: 'bold',
            alignItems: 'center',
            height: '100%',
            backgroundColor: '#FFFFFF',
            userSelect: 'none',
            textAlign: 'center',
            border: '0px',
            color: '#717786',
          }}
        >
          {cellData.value}
        </div>
      )}
    />
  );

  // Dynamically create columns for h0 to h23
  const dataColumns = Array.from({ length: 24 }, (_, colIndex) => (
    <Column
      key={`h${colIndex}`}
      dataField={`h${colIndex}`}
      cellRender={cellRender}
      caption={`${colIndex}`}
      width={32}
      allowSorting={false}
      allowFiltering={false}
      allowEditing={false}
      columnAutoWidth={false}
      alignment='center'
      headerCellRender={() => (
        <div style={{ border: '0px' }}>
          {String(colIndex).padStart(2, '0')} 
        </div>
      )}
    />
  ));

  return (
    <div class="interval-chart" style={{ justifyItems: 'center', marginTop: 20, minWidth: '856px' }}>
      <span className='titles' style={{ textAlign: 'center', marginBottom: '20px', marginTop: 0 }}>
        AI Result Overview
      </span>
      {      loading ? (
        <LoadIndicator
          width={50}
          height={50}
          visible={true}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', marginTop: '20px' }}
        />
      ) : (
        <>
      {/* Axis Titles */}
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
        <span className="text-center-small" >Time (Hour)</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
        {/* Y-Axis Title */}
        <div className="text-center-small" style={{ display: 'flex', writingMode: 'vertical-rl', transform: 'rotate(180deg)', marginRight: '10px', justifyContent: 'center' }}>
          Time (Minute)
        </div>
        <DataGrid
          dataSource={data}
          showBorders={false}
          columnAutoWidth={false}
          allowColumnReordering={false}
          allowColumnResizing={false}
          rowAlternationEnabled={false}
          showColumnLines={true}
          showRowLines={true}
          sorting={{ mode: 'none' }}
          filterRow={{ visible: false }}
          paging={{ enabled: false }}
          editing={{ mode: 'none' }}
          borders={false}
          width={801}
        >
          {rowTitleColumn}
          {dataColumns}
        </DataGrid>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '10px',
          gap: '20px',
          fontFamily: 'Open Sans',
          fontSize: '12px',
          lineHeight: '16px',
        }}
      >
        {/* No Data */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <div
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: '#FFFFFF', // White for no data
              border: '1px solid #000',
            }}
          ></div>
          <span className="text-center-small">No Data</span>
        </div>

        {/* No Risk Detected */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <div
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: '#D7E3FF', // Blue for no risk
              border: '1px solid #000',
            }}
          ></div>
          <span className="text-center-small">No Risk Detected</span>
        </div>

        {/* Risk Detected */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <div
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: '#FFDAD6', // Red for risk
              border: '1px solid #000',
            }}
          ></div>
          <span className="text-center-small">Risk Detected</span>
        </div>

        {/* CMM Mode */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <div
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: '#FFFFFF', // White for CMM mode
              border: '1px solid #000',
            }}
          ></div>
          <span className="text-center-small">CMM Mode</span>
        </div>

        {/* UAM Mode */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <div
            style={{
              width: '20px',
              height: '20px',
              backgroundColor: '#FFFFFF', // White with U for UAM mode
              border: '1px solid #000',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontWeight: 'bold',
            }}
          >
            U
          </div>
          <span className="text-center-small">UAM Mode</span>
        </div>
      </div>
      </>
      )}
    </div>
  );
};

export default IntervalChart;